import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { Http, Response, Headers } from "@angular/http";

@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }

  public saveUser(user){
    return this.http.post('http://gmhackathon-prod.us-east-1.elasticbeanstalk.com/api/user/signup', user);
  }

}



// WEBPACK FOOTER //
// C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/src/app/user.service.ts